import { Grid, TextField, Typography, FormControlLabel, Switch, useTheme } from '@mui/material';
import { Field } from 'formik';

interface LockerBasicInfoProps {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  errors: any;
  touched: any;
}

export function LockerBasicInfo({ mode, isSubmitting, errors, touched }: LockerBasicInfoProps) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Dados Básicos
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Nome do Armário"
          name="name"
          required
          disabled={isSubmitting}
          error={!!(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          placeholder="Ex: Armário Principal"
        />
      </Grid>
      {mode === 'create' && (
        <Grid item xs={12} sm={3}>
          <Field
            as={TextField}
            fullWidth
            label="Quantidade de Armários"
            name="locker_quantity"
            type="number"
            disabled={isSubmitting}
            error={!!(touched.locker_quantity && errors.locker_quantity)}
            helperText={touched.locker_quantity && errors.locker_quantity}
            inputProps={{ min: 1 }}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={mode === 'create' ? 3 : 6}>
        <FormControlLabel
          control={
            <Field name="is_available">
              {({ field }: { field: any }) => (
                <Switch
                  {...field}
                  checked={field.value}
                  color="primary"
                  disabled={isSubmitting}
                />
              )}
            </Field>
          }
          label={
            <Typography color={theme.palette.text.primary} fontWeight={500}>
              Disponível
            </Typography>
          }
        />
      </Grid>
    </>
  );
} 